// --------------------------------------------------------------------------
// #54 - LOAD MORE
// --------------------------------------------------------------------------
// Author:      Alex Baulch, Thomas Jeatt
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1.1
// --------------------------------------------------------------------------

/* global picturefill */

'use strict';

var $ = require('jquery');
var reinitModules = require('../../utilities/reinit-modules');

module.exports = function (options) {
    var context = options.context;

    /// Init function from app.js
    function reinitialiseModules() {
        var modules = [{
            name: 'personal-plan-activity-completion',
            module: require('./personal-plan-activity-completion')
        }, {
            name: 'social-reward-modal',
            module: require('../rewarding/social-reward-modal.js')
        }];

        reinitModules(modules);
    }

    function getResults(config) {
        var url = config.href;

        return $.ajax({
            method: 'GET',
            url: url
        });
    }

    function init() {
        context.on('click', '[data-binding="personal-plan-load-activities-button"]', function (e) {
            e.preventDefault();

            var activitiesList = context.find('[data-binding="personal-plan-activities-list"]');
            /// Variables scoped to active button
            var activeButton = $(this);
            var href = activeButton.attr('href');
            var loadingText = activeButton.data('loading-text');
            var buttonText = activeButton.find('.button__text').text();

            if (!activeButton.hasClass('disabled')) {
                activeButton.addClass('disabled');
                activeButton.find('.button__text').text(loadingText);

                getResults({
                    href: href
                }).done(function (data) {
                    var $data = $(data);
                    var ajaxActivitiesList = $data.find('[data-binding="personal-plan-other-activities-list"]');
                    var ajaxActivitiesListItems = ajaxActivitiesList.find('[data-binding="personal-plan-activity-item"]');
                    var ajaxButtonLoadMore = $data.find('.button--load-more');

                    if (ajaxActivitiesListItems.length) {
                        activitiesList.append(ajaxActivitiesListItems);
                        if (typeof window.HTMLPictureElement !== 'function') {
                            picturefill();
                        }
                    }

                    /// Check if there are more results to load otherwise remove loading buttons
                    if (ajaxButtonLoadMore.length) {
                        /// Update URLs
                        var ajaxLoadMoreUrl = ajaxButtonLoadMore.attr('href');

                        activeButton.attr('href', ajaxLoadMoreUrl);

                        /// Remove loading styles and text from active button
                        activeButton.removeClass('disabled').blur();
                        activeButton.find('.button__text').text(buttonText);
                    } else {
                        activeButton.remove();
                    }

                    reinitialiseModules();
                    init();
                });
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/personal-plan/personal-plan-activities-load.js
// module id = 104
// module chunks = 0